import { Component, OnInit } from "@angular/core";
import { locale as italian } from "../../../../i18n/it";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-resigned-employees",
  templateUrl: "./resigned-employees.component.html",
  styleUrls: ["./resigned-employees.component.scss"],
})
export class ResignedEmployeesComponent implements OnInit {
  public contentHeader: IContentHeader;

  public resignedEmployees: any = [];

  public tableLimit: number = 10;

  public searchKey: string = "";

  public filteredResignedEmployees: any = [];

  constructor(
    private _userService: UserService,
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    public _modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
    this._utilService.disableAutoHideLoading();
    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.searchKey = params.hasOwnProperty("q") ? params.q : "";
    });
    this.contentHeader = {
      headerTitle: italian.data.MENU.RESIGNED_EMPLOYEE,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.USERS,
            isLink: false,
          },
          {
            name: italian.data.MENU.RESIGNED_EMPLOYEE,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("view_resigned_employees")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    await this.loadResignedEmployees();
    await this.searchResignedEmployees();
  }

  async loadResignedEmployees() {
    this.resignedEmployees = await this._userService.getFutureResignedEmployees().then((results: any) => {
      return results.map((employee: any) => {
        employee.date = employee.closed_at ? this._utilService.formatDate(employee.closed_at) : this._utilService.formatDate(employee.end_date);
        return employee;
      });
    });
    this._utilService.hideLoading();
  }

  async searchResignedEmployees() {
    const key: string = this.searchKey.trim().toLowerCase();
    let filteredResignedEmployees: any = this.resignedEmployees;
    if (key.length > 0) {
      filteredResignedEmployees = filteredResignedEmployees.filter((item: any) => {
        return item.complete_name.toLowerCase().includes(key);
      });
    }
    this.filteredResignedEmployees = filteredResignedEmployees;
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }
}
